import CTLBooleanCell from "application/components/CTLBooleanCell";

const getMultiUpdateColumns = () => {
  return [
    {
      Header: "IsActive",
      accessor: "isActive",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "boolean",
      width: 12,
      controlType: "boolean",
      Cell: ({ value }) => <CTLBooleanCell value={value} />,
    },
  ];
};

export { getMultiUpdateColumns};
